export default __webpack_public_path__ + "static/media/Dragon Tear.695d82d8.jpg";